import { useState, useEffect, useRef } from "react";
import { GetMocktestQuestion } from "../../../Client/request";

export const useSpeakingQuestion = (quest, onQuestionLoaded) => {
  const [questData, setQuestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageLoading, setImageLoading] = useState(true);
  const onQuestionLoadedRef = useRef(onQuestionLoaded);

  // Update ref when callback changes
  useEffect(() => {
    onQuestionLoadedRef.current = onQuestionLoaded;
  }, [onQuestionLoaded]);

  useEffect(() => {
    if (quest) {
      setLoading(true);
      setImageLoading(true);
      setQuestData(null);
      GetMocktestQuestion(quest?.QuestionId).then((res) => {
        if (res.data) {
          setQuestData(res.data);
          setLoading(false);
          onQuestionLoadedRef.current?.();
        } else {
          setLoading(false);
        }
      }).catch((error) => {
        console.error('Error fetching question:', error);
        setLoading(false);
      });
    }
  }, [quest]);

  return { questData, loading, imageLoading, setImageLoading };
};
